import { useContext } from 'react';
import { ToastContext, ToastProvider } from './toast/ToastProvider';

const useToast = () => useContext(ToastContext);

export { useToast, ToastProvider };
